import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

class AddSubseasonModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      seasonId: this.props.seasonId,
      ssid: this.props.ssid,
      subseasonName: '',
      startDate: moment().utc().format("YYYY-MM-DD"),
      disableSubmit: false
    };

    this.handleInputChg = this.handleInputChg.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.seasonId !== this.props.seasonId || prevProps.ssid !== this.props.ssid) {
      this.setState({
        seasonId: this.props.seasonId,
        ssid: this.props.ssid,
        startDate: moment().utc().format("YYYY-MM-DD"),
        subseasonName: '',
        disableSubmit: false
      });
    }
  }

  handleInputChg(e) {
    const { id, value } = e.target;
    this.setState({ [id]: value });
  }

  handleSave(e) {
    e.preventDefault();

    if (this.state.disableSubmit) return;

    const { seasonId, ssid, subseasonName, startDate } = this.state;
    if (!subseasonName || !startDate) {
      alert("Veuillez remplir tous les champs");
      return;
    }

    this.setState({ disableSubmit: true });
    const _this = this;

    console.log("handleSave: this.state")
    console.log(this.state)


    Axios.post('/api/seasons/subseason/add', {
      seasonObjId: seasonId,
      subSeasonId: String(ssid),
      subseasonName: subseasonName,
      startDate: startDate,
      divisions: [{ name: 'Division par défaut', teams: [] }]
    })
    .then(function(response) {
      _this.props.reloadSeason();
      _this.props.handleModalCancel();
    })
    .catch(function(error) {
      console.log(error);
      _this.props.handleModalCancel();
    });
  }

  render() {
    return (
      <Modal 
        isOpen={this.props.showModal}
        size="sm"
        className={this.props.className}>

        <form className="form-horizontal" onSubmit={this.handleSave}>
          <ModalHeader>
            Ajout d'une sous-saison
          </ModalHeader>

          <ModalBody>
            {this.dispForm()}
          </ModalBody>

          <ModalFooter>
            <button type="button" className="btn btn-secondary btn-sm stdCommandButton2"
              onClick={this.props.handleModalCancel}>Annuler</button>
            <button type="submit" className="btn btn-primary btn-sm stdCommandButton2"
              disabled={this.state.disableSubmit}>Ajouter</button>
          </ModalFooter>
        </form>
      </Modal>
    );
  }

  dispForm() {
    return (
      <div>
        <div className="row row-margin-bottom-10">
          <div className="col-12">
            <span className="small">Nom</span><br/>
            <input className="form-control form-control-sm" type="text" id="subseasonName"
              value={this.state.subseasonName} onChange={this.handleInputChg} />
          </div>
        </div>

        <div className="row row-margin-bottom-10">
          <div className="col-12">
            <span className="small">Date de début</span><br/>
            <input className="form-control form-control-sm" type="date" id="startDate"
              value={this.state.startDate} onChange={this.handleInputChg} />
          </div>
        </div>
      </div>
    );
  }
}

export default AddSubseasonModal;